module.exports = __webpack_public_path__ + "static/undraw_QA_engineers_dg5p.75b2d092.svg";


//////////////////
// WEBPACK FOOTER
// /Users/stephan/skelware/savot/public/images/undraw/undraw_QA_engineers_dg5p.svg
// module id = 510
// module chunks = 0